<template>
  <div class="form__field" :style="{ width: field.size }">
    <div class="form__title" v-show="field.title">{{ field.title }}</div>
    <div class="form__spacer" v-show="field.title"></div>
    <label class="form__label" v-show="field.label" :for="identifier">
      {{ field.label }}
    </label>
    <div class="form__control">
      <datepicker
        input-class="form__input"
        v-model="value"
        format="dd. MMMM yyyy"
        :disabled-dates="disabledDates"
        :id="identifier"
        :language="de"
        :monday-first="mondayFirst"
        :name="identifier"
        :style="{ width: field.size }"
        @blur="validate()"
      />
    </div>
    <div
      class="form__message form__message--joined form__message--error"
      v-show="field.error"
    >
      {{ field.error }}
    </div>
    <div class="form__description" v-show="field.description">
      {{ field.description }}
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { de } from "vuejs-datepicker/dist/locale";

import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-date",
  components: {
    Datepicker
  },
  data() {
    return {
      de: de
    };
  },
  computed: {
    mondayFirst: function() {
      return true;
    },
    disabledDates: function() {
      if (!this.field.data || !this.field.data.disabledDates) {
        return {};
      }

      var disabledDates = {};

      Object.keys(this.field.data.disabledDates).forEach((key, index) => {
        let dateRegexp = /(\d{1,2})\.(\d{1,2})\.(\d{4})/;
        let value = this.field.data.disabledDates[key];

        if (typeof value === "string" || value instanceof String) {
          let [, day, month, year] = dateRegexp.exec(value);
          disabledDates[key] = new Date(
            parseInt(year),
            parseInt(month) - 1,
            parseInt(day)
          );
        }

        if (Array.isArray(value)) {
          disabledDates[key] = value.map(Number);
        }
      });

      return disabledDates;
    },
    value: {
      get() {
        if (!this.field.value) {
          return;
        }

        let [, day, month, year] = /(\d{1,2})\.(\d{1,2})\.(\d{4})/.exec(
          this.field.value
        );

        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      },
      set(value) {
        if (!value) {
          return null;
        }

        this.$store.dispatch("updateField", {
          field: this.field,
          newProps: {
            value:
              value.getDate() +
              "." +
              (value.getMonth() + 1) +
              "." +
              value.getFullYear()
          }
        });
      }
    }
  }
};
</script>
